import { Tooltip } from "@mui/material";

import useService from "../../../../../hooks/useService";
import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

import { ENTITY_TYPE_PROVIDER } from "./constants";

function formatCurrency(value) {
  return `$${Number(value || 0).toFixed(2)}`;
}

function SummaryCard({ title, value, highlight = null }) {
  const cardBackgroundColor =
    highlight === null
      ? HNSColors.tertiary[900]
      : highlight
        ? HNSColors.success[700]
        : HNSColors.failure[700];

  const valueColor =
    highlight === null
      ? HNSColors.neutrals[100]
      : highlight
        ? HNSColors.success[400]
        : HNSColors.failure[400];

  return (
    <div
      className="flex min-h-[88px] flex-col justify-between rounded-[12px] border px-4 py-3"
      style={{
        ...SETTLEMENT_STYLES.subtleBorder,
        backgroundColor: cardBackgroundColor,
      }}
    >
      <span className="text-[14px]" style={SETTLEMENT_STYLES.summaryCardTitle}>
        {title}
      </span>
      <Tooltip title={formatCurrency(value)} placement="top" arrow>
        <span
          className="block w-full truncate text-[18px] font-semibold"
          style={{ color: valueColor }}
        >
          {formatCurrency(value)}
        </span>
      </Tooltip>
    </div>
  );
}

export default function MedicalBreakdownSummary({ summary = {} }) {
  const currentUserService = useService("current-user-service");
  const loggedInUser = currentUserService?.user;
  const isProvider = loggedInUser?.entity?.entity_type_label === ENTITY_TYPE_PROVIDER;

  return (
    <div className="mt-4">
      <h4 className="text-[16px] font-semibold" style={SETTLEMENT_STYLES.subtitle}>
        Total Medical Reduction
      </h4>
      <div
        className={`mt-3 grid grid-cols-1 gap-3 md:grid-cols-2 ${isProvider ? "xl:grid-cols-3" : "xl:grid-cols-4"}`}
      >
        <SummaryCard title="Total Medical Bills" value={summary.totalMedicalBills} />
        <SummaryCard title="Total Settled Amount" value={summary.totalSettledAmount} />
        {!isProvider ? (
          <SummaryCard title="Total Medical Share" value={summary.totalMedicalShare} />
        ) : null}
        {!isProvider ? (
          <SummaryCard
            title="Remaining Unclaimed"
            value={summary.remainingUnclaimed}
            highlight={Number(summary.remainingUnclaimed || 0) > 0}
          />
        ) : null}
      </div>
    </div>
  );
}
